import MenuIcon from '@mui/icons-material/Menu';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import HomeIcon from '@mui/icons-material/Home';
import CalculateIcon from '@mui/icons-material/Calculate';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SellIcon from '@mui/icons-material/Sell';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import WorkIcon from '@mui/icons-material/Work';
import LanIcon from '@mui/icons-material/Lan';
import FactoryIcon from '@mui/icons-material/Factory';
import InventoryIcon from '@mui/icons-material/Inventory';
import ComputerIcon from '@mui/icons-material/Computer';
import DownloadIcon from '@mui/icons-material/Download';
import WaterDropIcon from '@mui/icons-material/WaterDrop';

// Single source of truth for nav-item icons. Keys are the exact strings stored in
// navigation.nv_icon; the management icon picker (Navigation.jsx) and the rendered
// sidebar (NavList.jsx) both read from this map, so an icon name is valid iff it is here.
export const NAV_ICONS = {
	MenuIcon: MenuIcon,
	LocalShippingIcon: LocalShippingIcon,
	HomeIcon: HomeIcon,
	CalculateIcon: CalculateIcon,
	EngineeringIcon: EngineeringIcon,
	SellIcon: SellIcon,
	SupportAgentIcon: SupportAgentIcon,
	CreditCardIcon: CreditCardIcon,
	WorkIcon: WorkIcon,
	LanIcon: LanIcon,
	FactoryIcon: FactoryIcon,
	InventoryIcon: InventoryIcon,
	ComputerIcon: ComputerIcon,
	DownloadIcon: DownloadIcon,
	WaterDropIcon: WaterDropIcon
};

export default NAV_ICONS;
